document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".site-header__nav").forEach((nav) => {
    const cursor = nav.querySelector(".site-header__cursor");
    const links = Array.from(nav.querySelectorAll(":scope > a"));
    if (!cursor) return;

    const clear = () => {
      cursor.style.opacity = "0";
      links.forEach((link) => link.classList.remove("is-active"));
    };

    links.forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const navRect = nav.getBoundingClientRect();
        const linkRect = link.getBoundingClientRect();
        cursor.style.left = `${linkRect.left - navRect.left}px`;
        cursor.style.width = `${linkRect.width}px`;
        cursor.style.opacity = "1";
        links.forEach((item) => item.classList.remove("is-active"));
        link.classList.add("is-active");
      });
    });

    nav.addEventListener("mouseleave", clear);
  });

  document.querySelectorAll("[data-brand-accordion]").forEach((accordion) => {
    const options = Array.from(accordion.querySelectorAll("[data-brand-option]"));
    options.forEach((option, index) => {
      setTimeout(() => option.classList.add("is-visible"), 180 * index);
      option.addEventListener("mouseenter", () => {
        options.forEach((item) => item.classList.remove("is-active"));
        option.classList.add("is-active");
      });
      option.addEventListener("click", () => {
        options.forEach((item) => item.classList.remove("is-active"));
        option.classList.add("is-active");
      });
    });
  });
});

/* Méga-menu "Nos produits" — hover-intent (gère l'espace lien↔panneau) + alignement dynamique sous le header */
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("[data-site-header]");
  document.querySelectorAll(".site-header__nav-item--mega").forEach((item) => {
    const panel = item.querySelector(".site-header__megamenu");
    // On déplace le panneau directement dans <body> : son bloc conteneur
    // devient le viewport, donc plus aucun ancêtre ne peut « piéger » son
    // position:fixed (fini les décalages en haut et à droite).
    if (panel) document.body.appendChild(panel);
    let closeTimer;
    const place = () => {
      if (header && panel) panel.style.top = header.getBoundingClientRect().bottom + "px";
    };
    const open = () => {
      clearTimeout(closeTimer);
      place();
      item.setAttribute("data-open", "");
      if (panel) panel.classList.add("is-open");
      document.querySelectorAll(".site-header__nav > a.is-active").forEach((a) => a.classList.remove("is-active"));
    };
    const scheduleClose = () => {
      closeTimer = setTimeout(() => {
        item.removeAttribute("data-open");
        if (panel) panel.classList.remove("is-open");
      }, 160);
    };
    item.addEventListener("mouseenter", open);
    item.addEventListener("mouseleave", scheduleClose);
    if (panel) {
      panel.addEventListener("mouseenter", open);
      panel.addEventListener("mouseleave", scheduleClose);
    }
    // Garde le panneau collé pile sous le header si on scroll/redimensionne pendant qu'il est ouvert.
    window.addEventListener("scroll", () => { if (item.hasAttribute("data-open")) place(); }, { passive: true });
    window.addEventListener("resize", () => { if (item.hasAttribute("data-open")) place(); });
  });
});
